import { render, staticRenderFns } from "./roleMenuBinding.vue?vue&type=template&id=0d9d6e9a&scoped=true&"
import script from "./roleMenuBinding.vue?vue&type=script&lang=js&"
export * from "./roleMenuBinding.vue?vue&type=script&lang=js&"
import style0 from "./roleMenuBinding.vue?vue&type=style&index=0&id=0d9d6e9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9d6e9a",
  null
  
)

export default component.exports